import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useState } from 'react';
import { useAsyncDebounce } from 'react-table';
// Define a default UI for filtering
const DefaultColumnFilter = ({ column: { filterValue, setFilter } }) => {
  const lang = useSelector((state) => state.local.local);
  const [value, setValue] = useState(filterValue);
  const onChange = useAsyncDebounce((value) => {
    setFilter(value);
  }, 800);
  return (
    <StyledDefaultColumnFilter
      value={value || ''}
      onChange={(e) => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
      placeholder={lang === 'ne' ? 'खोज्नुहोस' : 'Type to Search...'}
    />
  );
};

export default DefaultColumnFilter;

const StyledDefaultColumnFilter = styled.input`
  width: 100%;
  padding: 0 5px;
`;
